import React from 'react';

import { HeartIcon, ClipboardCopyIcon, DocumentTextIcon } from '@heroicons/react/outline'

const OrganizationSuccessStats = ({allMsgOrg, copiedOrg, likedOrg}) => {

    var all = allMsgOrg ? allMsgOrg?.length : 0;
    var copied = (allMsgOrg && copiedOrg) ? ((copiedOrg?.length / allMsgOrg?.length) * 100) : 0
    var liked = (allMsgOrg && likedOrg) ? ((likedOrg?.length / allMsgOrg?.length) * 100) : 0

    const stats = [
        { name: 'Total Prospected', stat:  all, icon: DocumentTextIcon,},
        { name: 'Messages Copied', stat:  (copied === 0) ? copied + ' %' : copied.toFixed(2) + ' %', icon: ClipboardCopyIcon, length: copiedOrg?.length},
        {   name: 'Fire Messages', 
            stat: (liked > 100) ? (<span> &gt; 100.00%</span>) : ((liked === 0) ? liked + ' %' : liked.toFixed(2) + ' %'),  
            icon: HeartIcon, href: '/likedProjects', length: likedOrg?.length
        },
    ]

    return (
        <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900 my-6">Team Total Prospects</h3>
            <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {stats.map((item) => (
                <div
                key={item.name}
                className="relative bg-white pt-5 px-4 pb-4 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden"
                >
                <dt>
                    <div className="absolute bg-green-500 rounded-md p-3">
                    <item.icon className="h-6 w-6 text-white" aria-hidden="true" />
                    </div>
                    <p className="ml-16 text-sm font-medium text-gray-500 truncate">{item.name}</p>
                </dt>
                <dd className="ml-16 flex items-baseline ">
                    <p className="text-2xl font-semibold text-gray-900">{item.stat}</p>
                </dd>
                {item.length > 0 ?
                <div className="font-medium text-gray-600 text-right my-2">
                    Amount: {item.length}
                </div>
                :
                null }
                </div>
            ))}
            </dl>
        </div>
    )
}

export default OrganizationSuccessStats